import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { hasEInvoicePermission as checkEInvoicePermission } from '../utils/permissions';

export function usePermissions() {
  const user = useSelector((state) => state.user.user);
  const loading = useSelector((state) => state.user.loading);

  const hasEInvoicePermission = useCallback(
    (permissionCode) => checkEInvoicePermission(user?.permissions, permissionCode),
    [user?.permissions],
  );

  return {
    permissions: user?.permissions,
    loading,
    hasEInvoicePermission,
  };
}
